import { render, staticRenderFns } from "./arbitrate.vue?vue&type=template&id=2c151c63&scoped=true"
import script from "./arbitrate.vue?vue&type=script&lang=js"
export * from "./arbitrate.vue?vue&type=script&lang=js"
import style0 from "./arbitrate.vue?vue&type=style&index=0&id=2c151c63&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__coffee-script@_nvev6wbrwofx6itvk2x4sio6cy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c151c63",
  null
  
)

export default component.exports